function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { clientErrorHandler } from '../..';
/**
 * Takes the cookie string from the document and returns an Array of
 * configured release toggle IDs using the key 'sm_release_toggles'.
 *
 * @param {string} cookie: Cookie string from document
 * @return {Array}
 */
export var getOverridesFromCookie = function getOverridesFromCookie(cookie) {
  if (!cookie) return [];
  var found = cookie.split(';').filter(function (elem) {
    return elem;
  }).map(function (elem) {
    return elem.split('=');
  }).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];
    return key && val;
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      val = _ref4[1];
    return {
      key: key.trim(),
      val: val.trim()
    };
  }).find(function (elem) {
    return elem.key === 'sm_release_toggles';
  });
  var toggles = [];
  if (found) {
    found.val.split(',').forEach(function (elem) {
      toggles.push(elem.trim());
    });
  }
  return toggles;
};

/**
 * Takes a URL string from the window.location object (must include query
 * params) and returns an Array of the configured release toggle IDs under the
 * key 'smReleaseToggles'.
 *
 * @param {string} url: HREF string from the window.location object
 * @return {*}
 */
export var getOverridesFromQueryParameters = function getOverridesFromQueryParameters(url) {
  if (!url) return [];
  var queryStrIndex = url.indexOf('?');
  if (queryStrIndex > -1) {
    var queryStr = url.slice(queryStrIndex + 1);
    var releaseToggles = queryStr.split('&').map(function (elem) {
      return elem.split('=');
    }).find(function (elem) {
      var _elem = _slicedToArray(elem, 1),
        key = _elem[0];
      return key === 'smReleaseToggles';
    });
    if (releaseToggles && releaseToggles.length > 1) {
      return releaseToggles[1].split(',').filter(function (elem) {
        return elem;
      });
    }
  }
  return [];
};

/**
 * Looks for a 'sm_release_toggles' cookie. If it exists, parses out the
 * comma-separated list of toggle IDs and returns a Set of the IDs.
 *
 * @return {Set}: IDs of enabled toggles
 */
export var getOverrides = function getOverrides(url, cookies) {
  // We know that this is from the Express req.
  if (typeof url === 'object' && typeof cookies === 'object') {
    var paramValues = (url.smReleaseToggles || '').split(',').map(function (elem) {
      return elem.trim();
    });
    var cookieValues = (cookies.sm_release_toggles || '').split(',').map(function (elem) {
      return elem.trim();
    });
    return new Set(paramValues.concat(cookieValues));
  }
  return new Set(getOverridesFromCookie(document.cookie).concat(getOverridesFromQueryParameters(window.location.href)));
};

/**
 * Component wraps code that isn't ready to be seen. Children are only
 * rendered if the 'releaseToggles' cookie or query parameter is set
 * where the value is a comma-separated list of toggle IDs
 * (IE. document.cookie="releaseToggles=ID1,ID2,ID3", whitespace is trimmed;
 * or https://localmonkey.com/my_page/?smReleaseToggles=ID1,ID2,ID3, no
 * whitespace trim) and the ID is in the list. If this component is rendered
 * on the client, these values are manually parsed from the window. If not,
 * they must be passed in through the queryParams and cookies props.
 *
 * Component may also have a child that is a function with the signature:
 * (isToggledOn: boolean) => Node which can be used to render a default
 * component in place of the feature component.
 *
 * If there is an error parsing the override cookies or params, it is caught,
 * logged and then the child function is called with false or null is returned.
 */
var ReleaseToggle = function ReleaseToggle(_ref5) {
  var toggleId = _ref5.toggleId,
    url = _ref5.url,
    cookies = _ref5.cookies,
    children = _ref5.children;
  var showToggle;
  try {
    showToggle = getOverrides(url, cookies).has(toggleId);
  } catch (err) {
    showToggle = false;
    // TODO: Remove this cast when clientErrorHandler has been typed
    clientErrorHandler.logError(err, 'There was a problem reading the override cookies and params in a ReleaseToggle');
  }
  if (typeof children === 'function') return children(showToggle);
  return showToggle ? children : null;
};
export default ReleaseToggle;
//# sourceMappingURL=index.js.map